import { TestResultsTable } from "../_components/TestResultsTable";

export default function AlumniTestResultsPage() {
  return (
    <TestResultsTable
      isAlumni={true}
      heading="PGM Program Alumni Test Results"
      body="Search for or view all alumni test results associated with this PGM University Program"
      searchPlaceholder="Search Alumni"
      testId="alumni-test-results-table"
    />
  );
}
